import InternalAvatar from './avatar';
import Group from './group';
export { AvatarProps } from './avatar';
export { GroupProps } from './group';
export { Group };
const Avatar = InternalAvatar;
Avatar.Group = Group;
export default Avatar;
